/**
 * Initializes date displays in ticket list items
 * Uses data attributes to pass date information from JSP to TypeScript
 */

import { setRelativeDateOrFormattedDate, setDateTooltip, formatDateLocale } from './date-utils';

export function initTicketListDates(): void {
  // Find all elements with data-date attribute (date display elements)
  document.querySelectorAll<HTMLElement>('[data-date]').forEach((element) => {
    const dateString = element.getAttribute('data-date');
    if (dateString && element.id) {
      // Set relative time or formatted date based on age
      setRelativeDateOrFormattedDate(dateString, element.id);
    }
  });

  // Find all tooltip elements with data-tooltip-date attribute
  document.querySelectorAll<HTMLElement>('[data-tooltip-date]').forEach((tooltipElement) => {
    const dateString = tooltipElement.getAttribute('data-tooltip-date');
    const tooltipId = tooltipElement.id;
    
    if (dateString && tooltipId) {
      // Find the corresponding date display element to get the date type prefix
      const dateDisplayElement = document.querySelector<HTMLElement>(
        `[data-tooltip-target="${tooltipId}"]`
      );
      
      if (dateDisplayElement) {
        const dateTypePrefix = dateDisplayElement.getAttribute('data-date-type') || '';
        // Set tooltip content with prefix, date, and time
        setDateTooltip(dateString, tooltipId, dateTypePrefix);
      }
    }
  });

  // Find all elements with data-deadline attribute (deadline badge elements)
  document.querySelectorAll<HTMLElement>('[data-deadline]').forEach((element) => {
    const deadlineString = element.getAttribute('data-deadline');
    if (deadlineString && element.id) {
      // Convert timestamp string to number, then to Date
      const deadlineTimestamp = Number(deadlineString);
      if (!isNaN(deadlineTimestamp)) {
        // Format deadline date using locale-specific format (date only, no time)
        const formattedDate = formatDateLocale(new Date(deadlineTimestamp));
        element.textContent = formattedDate;
      }
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTicketListDates);
} else {
  initTicketListDates();
}
